var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListCheck2 = function SvgListCheck2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.6 4.8h9v1.8h-9zm0 3.6H17v1.8h-5.4zm0 5.4h9v1.8h-9zm0 3.6H17v1.8h-5.4zM4.4 4.8h5.4v5.4H4.4zm1.8 1.8v1.8H8V6.6zm-1.8 7.2h5.4v5.4H4.4zm1.8 1.8v1.8H8v-1.8z"
  })));
};
export default SvgListCheck2;